import React from "react";
import styled from "styled-components"
import { Footnote } from "../../../util/typography";
import * as colors from "../../../util/colors"
import { Heading } from "../../../util/typography";
import { CONTAINER_MAX_WIDTH, NAVIGATION_BREAKPOINT } from "../../../constants/layout";
import { between } from "polished";
import { QsubWYSIWYG } from "../../../util/typography/WYSIWYG";
import * as Text from '../../../util/typography/Text';

const breakPoint = NAVIGATION_BREAKPOINT;


const QsubHomeBannerWrapper = styled.div`
 display: flex;
 flex-direction: row;
 gap:18px;
 max-width: 824px;
 width:100%;
 margin: auto;
 position:relative;

@media (min-width:${breakPoint}){
 max-height: 220px;
    &::before{
    content: "";
    position: absolute;
    bottom: 0px;
    left:0;
    width: 48%;
    height: 1px;
    background: linear-gradient(90deg, ${colors.white} 0%, ${colors.silver} 12%, ${colors.silver} 88%, ${colors.white} 100%);
    z-index: 1;
    }
}
 @media (max-width:${breakPoint}){
//  border-bottom: 1px solid ${colors.silver};
    flex-direction: column-reverse;
    gap: 20px;
 }
`;

const QsubHomeBannerImgMark = styled(Text.Footnote)`
position: absolute;
// bottom:15px;
// top: 90px;
// left:36px;
top: 15px;
left:0;
color: ${colors.concrete};
font-weight:500;

@media (max-width:${breakPoint}){
top: 250px;
bottom: unset;
left: 20px;
}
`
const QsubFootnote = styled(Footnote)`
margin-top:12px;
font-weight:500;
 @media (max-width:${breakPoint}){
        margin-top:8px;
    }
`

const QsubPurpleFootnote = styled(Text.Footnote)`
color: ${colors.lightPurple};
font-weight:400;
letter-spacing: 0.5px;
`
const QsubHomeBannerImgWrapper = styled.div`
    width: 48%;
    @media (max-width:${breakPoint}){
        width: 100%;
    }

`
const QsubHomeBannerImg = styled.img`
display:block;
max-width: 100%;
width: 100%;
height: 100%;
// object-fit:cover;
object-position: bottom;
`;

const QsubLogo = styled.img`
    width: 229.275px;
    height: 50.95px;
    margin: 7px 0 13px; 
    @media (max-width:${breakPoint}){
        max-width: 78%;
        padding: 8px 0 12px;
        height: 100%;
        margin: 0px; 
        }
       
`;

const QsubHomeBannerContent = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    padding: 16px 0;
    width: 52%;
    @media (max-width:${breakPoint}){
    padding: 20px 20px 0;
    width: 100%;
    }
`;

const QsubHomeBannerTileWrapper = styled.div`
    background: ${(props) => props.backColor};
    padding: 6.5px 20px 6.5px 10px;
    // margin-bottom:8px;
    position: relative;
    @media (min-width:${breakPoint}){
    padding: 9.5px 20px 9.5px 10px;
    }
    ${(props) => props.hasEdge ? 
        `&::after{
        content:"";
        position: absolute;
        width: 30px;
        height: 23px;
        bottom:-1px;
        right:-1px;
        background: ${colors.white};
        clip-path: polygon(100% 0,35% 100%,100% 100%);
        @media (max-width:${breakPoint}){
            width: 28px;
            height: 22px;
        }
    }`:
        ``
    }
    
    @media (min-width: ${breakPoint}){
        // margin-right:20px;
    }
    @media (max-width:${breakPoint}){
         padding:8px 14px 8px 12px;
        //  margin-bottom:6px;
        //  max-width: 212px;
       
    }
   
`
const QsubHomeBannerTileHeading = styled(Heading.H3)`
    color: ${colors.white};
    font-size: 20px;
    line-height: 26px;
    font-weight: 500;
        @media (max-width:${breakPoint}){
            font-size: 16px;
            line-height: 30px;
            // font-size: clamp(0.75rem, 0.1014rem + 3.2432vw, 1.875rem);
            // line-height: 2;
        }
`;
const BulletContainer = styled.div`
// width: 506px;

@media (max-width:${breakPoint}){
    width: 100%;
}
    ul li:first-child {
    margin-top: 16px;
    }
    >div{
    ul li{
    line-height:20px;
    }
    }
`;
const FootnoteContainer = styled.div`
margin-top: 10px;
>div{
span{
font-weight: 500;
}
}

@media (max-width: ${breakPoint}) {
margin-top: 14px;
}
`;

export const QsubHomeBannerTile = ({content,backColor,hasEdge=true}) =>{
    return(
        <QsubHomeBannerTileWrapper hasEdge={hasEdge} backColor={backColor ? backColor : colors.keytrudaGreen}>
            <QsubHomeBannerTileHeading>{content}</QsubHomeBannerTileHeading>
        </QsubHomeBannerTileWrapper>
    )
}

const QsubHomeBanner = ({imgSrc,mobSrc,children,imgMark,eyeBrowContent,logo, footNoteContent, imgAlt, logoAlt}) =>{
        return(
            <QsubHomeBannerWrapper>
                <QsubHomeBannerImgWrapper>
                {imgMark && <QsubHomeBannerImgMark>{imgMark}</QsubHomeBannerImgMark>}
                <picture>
                <source media={`(max-width:${breakPoint})`} srcSet={mobSrc} type="image/png"/>
                <QsubHomeBannerImg src={imgSrc} width={404} height={220} alt={imgAlt || ''} />
                </picture>
                </QsubHomeBannerImgWrapper>
                <QsubHomeBannerContent>
                    {eyeBrowContent && <QsubPurpleFootnote>
                        {eyeBrowContent}
                    </QsubPurpleFootnote> }
                    {logo && <QsubLogo src={logo} width={293} height={27} alt={logoAlt || ""} />}
                    {children}
                    <BulletContainer>
                    <FootnoteContainer>
                    <Footnote label="a." text="Does not account for all aspects of treatment. Actual clinic time may vary." />
                    </FootnoteContainer>
                    </BulletContainer> 
                    {/* {footNoteContent &&<QsubFootnote label="a." text="Does not account for all aspects of treatment. Actual clinic time may vary.">
                        {footNoteContent}
                    </QsubFootnote>} */}
                </QsubHomeBannerContent>
            </QsubHomeBannerWrapper>
        )
}

export default QsubHomeBanner;